import React from 'react';

export const AICopilotAvatar = ({ size = 32, className = '' }) => (
  <svg
    viewBox="0 0 200 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ width: size, height: size, flexShrink: 0 }}
    className={`rounded-full shadow-sm ${className}`}
  >
    {/* Soft Circular Background */}
    <circle cx="100" cy="100" r="96" fill="#E8EDF8" stroke="#D2DCF0" strokeWidth="4" />

    {/* Suit / Body */}
    <path
      d="M36 186C36 150 64 118 100 118C136 118 164 150 164 186V196H36V186Z"
      fill="#2E4374"
    />
    {/* Inner Jacket Fold */}
    <path d="M76 118L100 162L124 118Z" fill="#203054" />
    {/* White Shirt & Collar */}
    <path d="M84 118L100 152L116 118Z" fill="#FFFFFF" />
    <path d="M70 118L84 136L100 118Z" fill="#EDF2F9" />
    <path d="M130 118L116 136L100 118Z" fill="#EDF2F9" />
    {/* Tie */}
    <path d="M96 130L100 136L104 130L102 186H98L96 130Z" fill="#1C2744" />

    {/* Neck */}
    <rect x="88" y="100" width="24" height="22" fill="#F8FAFC" />

    {/* Head / Face Base */}
    <rect x="68" y="40" width="64" height="68" rx="32" fill="#FFFFFF" stroke="#263454" strokeWidth="5.5" />

    {/* Headset Band */}
    <path
      d="M65 60C65 38 79 22 100 22C121 22 135 38 135 60"
      stroke="#263454"
      strokeWidth="7"
      strokeLinecap="round"
      fill="none"
    />

    {/* Earcups / Headphones */}
    <rect x="54" y="52" width="18" height="40" rx="9" fill="#3B4D78" stroke="#263454" strokeWidth="4.5" />
    <rect x="128" y="52" width="18" height="40" rx="9" fill="#3B4D78" stroke="#263454" strokeWidth="4.5" />
    <rect x="58" y="58" width="10" height="28" rx="5" fill="#4B5E8A" />
    <rect x="132" y="58" width="10" height="28" rx="5" fill="#4B5E8A" />

    {/* Microphone Boom */}
    <path
      d="M138 76C150 76 150 102 122 102H115"
      stroke="#263454"
      strokeWidth="5"
      strokeLinecap="round"
      fill="none"
    />
    <circle cx="115" cy="102" r="6.5" fill="#1C2744" stroke="#263454" strokeWidth="2" />

    {/* Eyes */}
    <circle cx="85" cy="70" r="6.5" fill="#263454" />
    <circle cx="115" cy="70" r="6.5" fill="#263454" />

    {/* Mouth */}
    <path d="M91 88H109" stroke="#263454" strokeWidth="4.5" strokeLinecap="round" />
  </svg>
);

export default AICopilotAvatar;
